import { FC, memo } from 'react';

export const Spinner: FC = memo(() => (
  <div className="d-flex justify-content-center align-items-center vh-100 spinner-content">
    <div className="spinner-border text-primary" role="status">
      <span className="visually-hidden">Loading...</span>
    </div>
  </div>
));
